import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';

import type { TypeLegalTextSkeleton } from './TypeLegalText';

export interface TypeBlockLegalTextFields {
    internalName: EntryFieldTypes.Symbol;
    visibility?: EntryFieldTypes.Symbol<'loggedIn' | 'loggedOut'>;
    title: EntryFieldTypes.Symbol;
    legalText: EntryFieldTypes.EntryLink<TypeLegalTextSkeleton>;
    displayOption?: EntryFieldTypes.Symbol<'expandable'>;
    colorOption?: EntryFieldTypes.Symbol<'gray' | 'primary' | 'primary-negative' | 'secondary' | 'tertiary' | 'white'>;
}

export type TypeBlockLegalTextSkeleton = EntrySkeletonType<TypeBlockLegalTextFields, 'blockLegalText'>;
export type TypeBlockLegalText<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
    TypeBlockLegalTextSkeleton,
    Modifiers,
    Locales
>;

export function isTypeBlockLegalText<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: unknown,
): entry is TypeBlockLegalText<Modifiers, Locales> {
    const candidate = entry as { sys?: { contentType?: { sys?: { id?: string } } } };

    return candidate.sys?.contentType?.sys?.id === 'blockLegalText';
}
